import React from "react";
import { Button, Form } from "react-bootstrap";
import { firebaseServices } from "../../services/firebase";
import { Link } from "react-router-dom";
import { ROUTE_NAMES } from "../../Routes/routes";

import api from "../../api";

import LicenseAgreementModal from "../../components/LicenseAgreement";

export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      modalShow: false,
    };
    
  }
  async componentDidMount() {
    if (await firebaseServices.getCurrentUser()) {
      this.props.history.push(ROUTE_NAMES.dashboard);
    }

  }
  handleChange = (event) => {
    try {
      const { name, value } = event.target;
      this.setState({ [name]: value });
    } catch (error) {
      console.log(error);
    }
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const { email, password } = this.state;
    const { history } = this.props;
    try {
      await firebaseServices.signupWithEmail(email, password);

      localStorage.setItem(
        "user",
        JSON.stringify({ login_status: true, email: email })
      );

      await this.setState({ loading: false });

      this.showModal();
    } catch (error) {
      this.setState({ loading: false });
      alert(error);
    }
  };

  showModal = () => {
    this.setState({ modalShow: true });
  };

  hideModal = () => {
    this.setState({ modalShow: false });
  };
  acceptTerms = async () => {
    this.setState({ loading: true });
    const { history } = this.props;
    var payload = { email: this.state.email, terms_acceptance: true };
    console.log("payload:", payload);

    await api.insertCustomer(payload).then(
      (res) => {
        console.log("Response:", res);

        var user = JSON.parse(localStorage.user);
        user["id"] = res.data.id;
        console.log("user:", user);
        localStorage.setItem("user", JSON.stringify(user));
        alert("User created!")
        history.push(ROUTE_NAMES.initialSetup);
      },
      (error) => {
        alert(error);
        this.setState({ loading: false });
      }
    );
  };

  render() {
    const { loading, modalShow } = this.state;
    return (
      <div>
        <div className="d-flex align-items-center auth px-0 bg-gradient-success">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo">
                  <img
                    src={require("../../assets/images/logo.svg")}
                    alt="logo"
                  />
                </div>
                <h4>New here?</h4>
                <h6 className="font-weight-light">
                  Signing up is easy. It only takes a few steps
                </h6>
                <Form className="pt-3" onSubmit={this.handleSubmit}>
                  <Form.Group className="d-flex search-field">
                    <Form.Control
                      type="email"
                      name="email"
                      onChange={this.handleChange}
                      placeholder="Email address"
                      size="lg"
                      className="h-auto"
                    />
                  </Form.Group>
                  <Form.Group className="d-flex search-field">
                    <Form.Control
                      onChange={this.handleChange}
                      name="password"
                      type="password"
                      placeholder="Password"
                      size="lg"
                      className="h-auto"
                    />
                  </Form.Group>
                  <div className="mt-3">
                    <Button
                      className="btn btn-block btn-success btn-lg font-weight-medium auth-form-btn"
                      variant="primary"
                      block
                      type="submit"
                    >
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        >
                          {"  "}
                        </span>
                      ) : (
                        "SIGN UP"
                      )}
                    </Button>
                  </div>

                  <div className="text-center mt-4 font-weight-light">
                    Existing Brand?{" "}
                    <Link to={ROUTE_NAMES.home} className="text-primary">
                      Login
                    </Link>
                  </div>
                </Form>

                <LicenseAgreementModal
                  show={modalShow}
                  onHide={this.hideModal}
                  onSave={this.acceptTerms}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
